"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLang = exports.multiLangDesc = exports.multiLangName = exports.multiLang = exports.withKey = exports.withListener = exports.withNewId = exports.withHasValue = exports.withNewValue = exports.withEditList = exports.withEditForce = exports.withEdit = exports.withLoadForceBy = exports.withLoadBy = exports.withLoadForce = exports.withLoad = exports.withMount = exports.withState = exports.withParams = void 0;

var _ramda = require("ramda");

var _recompose = require("recompose");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var firstLetterToUpper = function firstLetterToUpper(str) {
  return str[0].toUpperCase() + str.slice(1);
};

var toLensPath = function toLensPath(s) {
  return s.replace(/\[/g, '.').replace(/\]/g, '').split('.');
};

var viewLens = function viewLens(s, o) {
  return (0, _ramda.view)((0, _ramda.lensPath)(toLensPath(s)), o);
};

var withParams = (0, _recompose.withProps)(function (props) {
  return _objectSpread({}, props.match.params);
});
exports.withParams = withParams;

var withState = function withState(prop, val) {
  return (0, _recompose.withState)(prop, 'set' + firstLetterToUpper(prop), val);
};

exports.withState = withState;

var withMount = function withMount(f) {
  return (0, _recompose.lifecycle)({
    componentDidMount: function componentDidMount() {
      f(this.props);
    }
  });
};

exports.withMount = withMount;

var withLoad = function withLoad(prop, key, field, force) {
  return (0, _recompose.lifecycle)({
    componentWillMount: function componentWillMount() {
      (force || (0, _ramda.isEmpty)(this.props[prop])) && this.props['get' + firstLetterToUpper(prop)](_defineProperty({}, key || 'id', this.props[field || 'id']));
    }
  });
};

exports.withLoad = withLoad;

var withLoadForce = function withLoadForce(prop, key, field) {
  return withLoad(prop, key, field, true);
};

exports.withLoadForce = withLoadForce;

var withLoadBy = function withLoadBy(prop, key, force) {
  return withLoad(prop, key, key, force);
};

exports.withLoadBy = withLoadBy;

var withLoadForceBy = function withLoadForceBy(prop, key) {
  return withLoad(prop, key, key, true);
};

exports.withLoadForceBy = withLoadForceBy;

var _withEdit = function _withEdit(p, prop, path, initObj) {
  var id = initObj && p[initObj.id] || +p.match.params.id;
  var list = toLensPath(path || prop + 's');
  var v = (0, _ramda.find)(function (x) {
    return x.id == id;
  }, (0, _ramda.view)((0, _ramda.lensPath)(list), p) || []);
  p.setForm(v || _objectSpread({}, initObj || {}, {
    id: id
  }), {
    path: prop
  });
};

var withEdit = function withEdit(prop, path, initObj) {
  return withNewValue(path && path.split('.')[0] || prop + 's', null, function (p) {
    return _withEdit(p, prop, path, initObj);
  });
};

exports.withEdit = withEdit;

var withEditForce = function withEditForce(prop, path, initObj) {
  return withHasValue(path && path.split('.')[0] || prop + 's', function (p) {
    return _withEdit(p, prop, path, initObj);
  });
};

exports.withEditForce = withEditForce;

var withEditList = function withEditList(prop) {
  return (0, _recompose.lifecycle)({
    componentWillMount: function componentWillMount() {
      var list = toLensPath(prop);
      var v = (0, _ramda.view)((0, _ramda.lensPath)(list), this.props);
      this.props.setForm(v, {
        path: list
      });
    }
  });
}; // triggered when a prop has a new value in the store. if no "val" provided, compared with old value


exports.withEditList = withEditList;

var withNewValue = function withNewValue(prop, val, cb) {
  return (0, _recompose.lifecycle)({
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
      var newValue = newProps[prop];
      var oldValue = this.props[prop];
      if ((0, _ramda.isNil)(val) ? !(0, _ramda.equals)(newValue, oldValue) : (0, _ramda.equals)(newValue, val) && !(0, _ramda.equals)(oldValue, val)) cb(newProps, newValue);
    }
  });
};

exports.withNewValue = withNewValue;

var withHasValue = function withHasValue(prop, cb) {
  return (0, _recompose.lifecycle)({
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
      if (!(0, _ramda.isNil)(newProps[prop]) && (0, _ramda.isNil)(this.props[prop])) cb(newProps, newValue);
    }
  });
};

exports.withHasValue = withHasValue;

var withNewId = function withNewId(path) {
  return (0, _recompose.withProps)(function (prop) {
    return {
      newId: (0, _ramda.reduce)(_ramda.max, 0, (viewLens(path, prop) || []).map(function (x) {
        return +x.id;
      })) + 1
    };
  });
};

exports.withNewId = withNewId;

var getEl = function getEl(id) {
  return id ? document.getElementById(id) : window;
};

var getListenerName = function getListenerName(event, id) {
  return "".concat(event, "_").concat(id || 'window', "_listener");
};

var withListener = function withListener(event, f, id) {
  return (0, _recompose.compose)((0, _recompose.withHandlers)(_defineProperty({}, getListenerName(event, id), function (p) {
    return function (e) {
      return f(p, e);
    };
  })), (0, _recompose.lifecycle)({
    componentDidMount: function componentDidMount() {
      getEl(id).addEventListener(event, this.props[getListenerName(event, id)]);
    },
    componentWillUnmount: function componentWillUnmount() {
      getEl(id).removeEventListener(event, this.props[getListenerName(event, id)]);
    }
  }));
};

exports.withListener = withListener;

var withKey = function withKey(f) {
  return withListener('keydown', function (p, e) {
    return f(p, e.key, e.keyCode);
  });
};

exports.withKey = withKey;

var multiLang = function multiLang(prop) {
  return function (lang) {
    return function (obj) {
      return obj[prop + '_' + lang] || obj[prop];
    };
  };
};

exports.multiLang = multiLang;
var multiLangName = multiLang('name');
exports.multiLangName = multiLangName;
var multiLangDesc = multiLang('desc');
exports.multiLangDesc = multiLangDesc;
var withLang = (0, _recompose.withProps)(function (props) {
  return {
    n: multiLangName(props.lang),
    d: multiLangDesc(props.lang)
  };
});
exports.withLang = withLang;